import { GoogleFormEmbedHandler } from "./handlers/GoogleFormEmbedHandler.js";
import { YouTubeEmbedHandler } from "./handlers/YouTubeEmbedHandler.js";
import { VimeoEmbedHandler } from "./handlers/VimeoEmbedHandler.js";
import { SoundCloudEmbedHandler } from "./handlers/SoundCloudEmbedHandler.js";
import { SpotifyEmbedHandler } from "./handlers/SpotifyEmbedHandler.js";
const EmbedHandlers = {
  GoogleForm: GoogleFormEmbedHandler,
  YouTube: YouTubeEmbedHandler,
  Vimeo: VimeoEmbedHandler,
  SoundCloud: SoundCloudEmbedHandler,
  Spotify: SpotifyEmbedHandler
};
export {
  EmbedHandlers
};
//# sourceMappingURL=index.js.map
